module.exports = __webpack_public_path__ + "static/img/lumi-character.e77a7d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lumi-character.png
// module id = xz+8
// module chunks = 1